﻿
import $ from "jquery";
import { AppLog } from "./AppLog";
import { VmFilterValue } from "./Interface/VmFilterValue";
import { IPager } from "./Interface/IPager";

export class GuiFilterSort {
    private timer?: number;
    private readonly attachPageEvents: (guiFilterSort: GuiFilterSort) => void;
    pager: IPager;
    constructor(public divErzList: JQuery, attachPageEvents: { (guiFilterSort: GuiFilterSort): void }) {
        AppLog.logInfo("GuiFilterSort");
        this.attachPageEvents = attachPageEvents; // Handler von Liste übergeben, um nach Paging spezielle Events anzuhängen
        this.pager = this.getPager();
        if (this.pager == undefined) return;


        this.attachSort();
        this.attachFilterEvents();
        this.formatSort();

        this.displayPager();
        this.displayFilter();
        this.displayResetFilterButton();

        this.attachPageEvents(this);

        this.divErzList.data("lastfilter", this.createFilter());

        this.setIconColor();
    }



    // #region ### Filter ###   

    private filterAction(e: JQuery.KeyDownEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) {
        if (e.keyCode === 13) {
            e.preventDefault();
            return;
        }
    }

    private filterIcon(e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) {
        console.log("filterIcon");
        let filterValue = $(e.currentTarget).data("filter-value");
        if (filterValue != null) filterValue = filterValue.toString().toLowerCase();

        // Three State Filter
        switch (filterValue) {
            case "":
            case null:
                filterValue = "true";
                break;
            case "true":
                filterValue = "false";
                break;
            case "false":
                filterValue = "";
                break;
        }

        $(e.currentTarget).data("filter-value", filterValue);

        this.setIconColor();

        this.filter();
    }

    private setIconColor() {
        AppLog.logInfo("setIconColor");
        const inputs = $("span[data-filter-name]", this.divErzList);
        let color = "";
        inputs.each((index, elem) => {
            const $ele = $(elem);
            const filterValue = $ele.data("filter-value").toString();

            AppLog.logInfo(elem.outerHTML + " " + filterValue.toString());

            // Three State Filter
            switch (filterValue) {
                case "":
                case null:
                    color = "erz-lightcolor";
                    break;
                case "true":
                    color = "text-color";
                    break;
                case "false":
                    color = "text-danger";
                    break;
            }

            AppLog.logInfo(color);

            $ele.removeClass("erz-lightcolor").removeClass("text-success").removeClass("text-danger").addClass(color);
        });
    }


    private startSearchTimer() {
        clearTimeout(this.timer);
        this.timer = window.setTimeout(() => { this.filter(); }, 300);
    }

    private attachFilterEvents() {
        AppLog.logInfo("attachFilterEvents");

        $("input[data-filter-name]", this.divErzList).on("keydown", (e: JQuery.KeyDownEvent) => this.filterAction(e));
        $("input[data-filter-name]", this.divErzList).on("input", () => this.startSearchTimer()); // clear thru x

        $("select[data-filter-name]", this.divErzList).on("change", () => this.startSearchTimer());
        $("span.erz-filter", this.divErzList).on("click", (e: JQuery.ClickEvent) => this.filterIcon(e));

        // Elemente mit erz-list-extra-filter können außerhalb von div.erz-list liegen (z.B. AVV-Vorschlagsfilter).
        // Analog zu den internen Filtern: Texteingaben via input-Event, Checkboxes/Selects via change, Drei-Zustand-Spans via click.
        $("input[data-filter-name].erz-list-extra-filter:not([type='checkbox'])").on("input", () => this.startSearchTimer());
        $("input[type='checkbox'][data-filter-name].erz-list-extra-filter, select[data-filter-name].erz-list-extra-filter").on("change", () => this.startSearchTimer());
        $("span.erz-filter[data-filter-name].erz-list-extra-filter").on("click", (e: JQuery.ClickEvent) => this.filterIcon(e));
    }

    // Liest den Filterwert eines Elements anhand seines DOM-Typs aus (Checkbox, Drei-Zustand-Span, oder Textwert).
    private extractFilterValue($ele: JQuery, elem: HTMLElement): string {
        if (elem.nodeName === "INPUT" && (elem as HTMLInputElement).type === "checkbox")
            return $ele.is(":checked") ? "true" : "false";
        if ($ele.hasClass("erz-filter"))
            return $ele.data("filter-value") as string;
        return $ele.val() as string;
    }

    /* 
        Darstellung des aktuellen Filters
    */
    private displayFilter() {
        AppLog.logInfo("displayFilter");

        const inputs = $("input[data-filter-name],select[data-filter-name],span[data-filter-name]", this.divErzList);

        const jsonString = this.divErzList.data("lastfilter");
        let filterValues: VmFilterValue[] = [];

        if (typeof jsonString === "string") {
            filterValues = JSON.parse(jsonString) as VmFilterValue[];
        } else if (Array.isArray(jsonString)) {
            filterValues = jsonString as VmFilterValue[];
        }

        if (filterValues != undefined) {
            filterValues.forEach((o) => {
                const ele = inputs.filter(`[data-filter-name='${o.FilterName}']`);
                if (ele.length === 1) {
                    // TODO: select und span einbauen
                    ele.val(o.FilterValue);
                }
            });
        }

    }


    /*
        festlegen, ob der Reset Button angzeigt wird.
        Dieser wird gezeigt, wenn ein Filter gesetzt oder die Sortierung nicht dem Default entspricht
        oder nicht Seite 1 angzeigt wird
    */
    private displayResetFilterButton() {
        AppLog.logInfo("displayResetFilterButton");

        const btn = $("#btnResetFilter")
        let show = false;

        if (this.pager.Filter.filter(o => o.FilterValue != "").length != 0) {
            show = true;
        }

        if (this.pager.CurrentPage != 1) {
            show = true;
        }
        let defaultSort = this.divErzList.data("sortdefaultdirection") as string;
        if (defaultSort == undefined) defaultSort = "ASC";
        if (!(this.pager.SortColumn == this.divErzList.data("sortdefault") && this.pager.SortDirection == defaultSort)) {
            show = true;
        }

        // Über die Klasse statt show()/hide(): der Button kommt mit d-none vom Server (kein Aufflackern),
        // und d-none ist !important - show() allein würde ihn nicht einblenden.
        btn.toggleClass("d-none", !show);

    }

    private createFilter(): Array<VmFilterValue> {
        const listFilter: Array<VmFilterValue> = [];

        // Filterelemente innerhalb von div.erz-list
        $("input[data-filter-name],select[data-filter-name],span[data-filter-name]", this.divErzList).each((index, elem) => {
            const $ele = $(elem);
            const filterValue = new VmFilterValue();
            filterValue.FilterName = $ele.data("filter-name");
            filterValue.FilterValue = this.extractFilterValue($ele, elem);
            listFilter.push(filterValue);
        });

        // Filterelemente mit erz-list-extra-filter liegen außerhalb von div.erz-list
        $("[data-filter-name].erz-list-extra-filter").each((index, elem) => {
            const $ele = $(elem);
            const filterValue = new VmFilterValue();
            filterValue.FilterName = $ele.data("filter-name");
            filterValue.FilterValue = this.extractFilterValue($ele, elem);
            listFilter.push(filterValue);
        });

        return listFilter;
    }

    private filter() {
        AppLog.logInfo("filter");

        const currentFilter = this.createFilter();
        const json = JSON.stringify(currentFilter);

        const lastFilter = this.divErzList.data("lastfilter");
        if (lastFilter != undefined && json == JSON.stringify(lastFilter)) {
            AppLog.logInfo("keine Änderung im Filter");
            return; // keine Änderung im Filter
        }

        this.divErzList.data("lastfilter", currentFilter);
        this.lock();

        const token = $("[name=__RequestVerificationToken]").val();
        AppLog.logInfo(`securityToken:${token}`);
        AppLog.logInfo(`filter:${json}`);

        const url = this.divErzList.data("filter-url");
        $.ajax({
            type: "POST",
            url: url,
            dataType: "html",
            data: {
                __RequestVerificationToken: token,
                listFilter: json
            },
            contentType: "application/x-www-form-urlencoded"
        }).done((data: string) => {
            this.display(data);
        })
            .always(() => { this.unlock(); });


    }

    // #endregion

    // #region ### Sort ###

    private attachSort() {
        $("div.erz-list-header [data-sort-name]", this.divErzList).on("click", (e) => { this.clickSort(e) });
    }

    private clickSort(e: JQuery.ClickEvent) {
        AppLog.logInfo(`clickSort`);

        this.fadeRows();

        const sortName = $(e.currentTarget).data("sort-name");
        const url = this.divErzList.data("sort-url") + "?sortname=" + sortName;
        AppLog.logInfo(`clickSort ${url}`);
        this.lock();
        $.ajax({
            type: "GET",
            url: url,
            dataType: "html"
        }).done((data: string) => { this.display(data); })
            .always(() => { this.unlock(); });
    }

    // #endregion

    // #region ### Pager ###

    private attachPagerEvents() {
        $("li.page-item button", this.divErzList).on("click", (e) => { this.clickPager(e); });
    }

    private clickPager(e: JQuery.ClickEvent) {
        AppLog.logInfo(`clickPager`);
        e.preventDefault();
        const page = $(e.currentTarget).data("page");
        this.gotoPage(page);
    }

    private displayPager() {
        AppLog.logInfo(`displayPager`);
        if (this.pager == undefined) return;

        // Position Datensätze footer
        $("#assistentpager").html(`${this.pager.NavText} ${this.pager.StartRow}-${this.pager.EndRow} (Gesamt ${this.pager.CountGesamt})`);

        const navPager = $("nav.erz-list-pager", this.divErzList);
        const ul = $("ul.pagination", navPager);
        ul.empty();

        // Wenn keine Datensätze --> keine Pager
        if (this.pager.CountGesamt === 0) return;
        if (this.pager.Pages == undefined || this.pager.Pages.length === 1) return;

        const liFirst = `<li class="page-item"><button class="page-link" data-page="${this.pager.FirstPage}"><i class="fa fa-angle-double-left"></i></button></li>`;
        const liBack = `<li class="page-item"><button class="page-link" data-page="${this.pager.PrevPage}"><i class="fa fa-angle-left"></i></button></li>`;
        const liNext = `<li class="page-item"><button class="page-link" data-page="${this.pager.NextPage}"><i class="fa fa-angle-right"></i></button></li>`;
        const liLast = `<li class="page-item"><button class="page-link" data-page="${this.pager.LastPage}"><i class="fa fa-angle-double-right"></i></button></li>`;

        if (this.pager.CurrentPage !== this.pager.FirstPage) ul.append(liFirst);
        if (this.pager.PrevPage !== 0) { ul.append(liBack); }

        for (let i = 0; i < this.pager.Pages.length; i++) {
            const pageNo = this.pager.Pages[i];
            const liPage = $(`<li class='page-item'><Button class='page-link' data-page='${pageNo}'>${pageNo}</Button></li>`);
            if (pageNo === this.pager.CurrentPage) {
                liPage.addClass("active");
            }
            ul.append(liPage);
        }

        if (this.pager.NextPage !== 0) { ul.append(liNext); }
        if (this.pager.CurrentPage !== this.pager.LastPage) ul.append(liLast);
        this.attachPagerEvents();
    }


    private formatSort() {
        AppLog.logInfo("formatSort");
        // Sort Icons einblenden
        // Alle Sort icons entfernen
        $(`div.erz-list-header [data-sort-name] svg`, this.divErzList).remove();

        AppLog.logInfo(`SortColumn=[${this.pager.SortColumn}] SortDirection=[${this.pager.SortDirection}]`);

        const spanDown = "<i class='fa fa-sort-alpha-down' style='margin-left: 5px;margin-right: 5px;'></i>";
        const spanUp = "<i class='fa fa-sort-alpha-up' style='margin-left: 5px;margin-right: 5px;'></i>";
        //const spanUpDown = "<i class='fa fa-arrows-up-down' style='margin-left: 5px;margin-right: 5px;'></i>";

        const th = $(`div.erz-list-header [data-sort-name='${this.pager.SortColumn}']`, this.divErzList);
        if (this.pager.SortDirection === "ASC")
            th.append($(spanDown));
        else
            th.append($(spanUp));

        //$(`div.erz-list-header span[data-sort-name]`, this.divErzList)
        //    .not($(`div.erz-list-header [data-sort-name='${this.pager.SortColumn}']`, this.divErzList))
        //    .append($(spanUpDown));


    }

    public gotoPage(pageno: number) {
        AppLog.logInfo(`gotoPage ${pageno}`);

        this.lock();

        const url = this.divErzList.data("page-url") + "?pageno=" + pageno;
        $.ajax({
            type: "GET",
            url: url,
            dataType: "html"
        }).done((data: string) => { this.display(data); })
            .always(() => {
                this.unlock();
            });
    }

    display(data: string) {

        // Prüfen, ob ein Fehler vorliegt
        if (data != undefined && data.indexOf("<!DOCTYPE html>") === 0) {
            AppLog.logInfo("Error in Result");
            window.location.href = "/"; // Bei Logout wird weiterleitung auf Login durchgeführt
            return;
        }

        this.divErzList.find("div.erz-list-body")[0].outerHTML = data;
        $("div.erz-list-body div", this.divErzList).hide().fadeIn(500);
        this.pager = this.getPager();
        this.formatSort();
        this.displayPager();
        this.displayResetFilterButton();
        this.attachPageEvents(this);

    }

    private lock() {
        this.divErzList.addClass("erz-loading");
    }

    private unlock() {
        this.divErzList.removeClass("erz-loading");
    }

    private fadeRows() {
        // Zeilen ausblenden
        $("erz-list-body", this.divErzList).fadeOut(1000);
    }

    private getPager(): IPager {
        const pagerJson = $("div.erz-list-body", this.divErzList).data("listnavi") as IPager;
        AppLog.logInfo(`getPager ${pagerJson}`);

        if (pagerJson != null) AppLog.logInfo(pagerJson.toString());
        return pagerJson as IPager;
    }

}
